interface LoadingScreenProps {
  open: boolean;
}

export default function LoadingScreen({ open }: LoadingScreenProps) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
      <div className="animate-spin rounded-full h-24 w-24 border-t-4 border-b-4 border-yellow-400"></div>
    </div>
  );
} 